// extracted by mini-css-extract-plugin
module.exports = {"title":"bottom-module--title--1MItP","link":"bottom-module--link--d2LQm","description":"bottom-module--description--1750D"};